import { render, staticRenderFns } from "./PopupConfirm.vue?vue&type=template&id=dfe36fae&scoped=true&"
import script from "./PopupConfirm.vue?vue&type=script&lang=js&"
export * from "./PopupConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PopupConfirm.vue?vue&type=style&index=0&id=dfe36fae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe36fae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
